import axios from "axios";
import { AUTHORIZATION_INFO } from "@pga/utils/constance/constance";
import { ServiceType_Enum } from "../types/common";
import localStorageService from "./localStorageService";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { checkBaseUrlSlash } from "@pga/utils/checkUrlSlash/checkUrlSlash";

const Api = (
  notRequireAuth: boolean = false,
  signal?: AbortSignal,
  baseURL?: string,
  Type?: ServiceType_Enum,
  callExportGrid?: boolean
) => {
  // base
  const BASE_URL = baseURL ?? checkBaseUrlSlash()!;
  const getAccessTokenUrl: string = process.env.REACT_APP_GET_ACCESS_TOKEN!;
  const sAlert = withReactContent(Swal);
  const CheckHealthUrl: string = process.env.REACT_APP_CHECK_HEALTH!;
  const kioskSerialNo = window.location.pathname.split("/")[2];

  const api = axios.create({
    withCredentials: false,
    baseURL: BASE_URL,
    responseType: callExportGrid ? "arraybuffer" : undefined,

    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": callExportGrid ? "application/json" : undefined,
    },
    signal: signal,
  });

  const routerPrivate = async () => {
    localStorageService.remove(AUTHORIZATION_INFO);
  };

  // بسته به اینکه در چه پلتفرمی می باشد باید به صفحه ورود مربوطه برویم
  function goToLogin() {
    localStorageService.remove(AUTHORIZATION_INFO);
    if (window.location.pathname.includes("kiosk"))
      window.location.href = `/kiosk/${kioskSerialNo}/login`;
    else window.location.href = `/login`;
  }
  // آپدیت توکن
  const lsTokenReferesh = async () => {
    let lsData = localStorageService.get(AUTHORIZATION_INFO);
    const data: any = lsData || null;
    if (data && data.accessTokenExpiration) {
      const toKenExpireDate = new Date(data.accessTokenExpiration);
      const refereshTokenExpireDate = new Date(data.refreshTokenExpiration);
      const now = new Date();
      if (toKenExpireDate < now) {
        if (refereshTokenExpireDate < now) {
          goToLogin();
        } else {
          try {
            const resData = await axios.get(`${BASE_URL}${getAccessTokenUrl}`, {
              headers: { Authorization: "Bearer " + data.accessToken },
            });

            if (resData.data.success) {
              localStorageService.set(AUTHORIZATION_INFO, resData.data.data);
            } else {
              goToLogin();
            }
          } catch (error) {
            goToLogin();
          }
        }
      }
    } else {
      goToLogin();
    }
  };

  // Add a request interceptor
  api.interceptors.request.use(
    async (config: any) => {
      if (!notRequireAuth) {
        const token = localStorageService.get(AUTHORIZATION_INFO)?.accessToken;
        config.headers["Authorization"] = "Bearer " + token;

        const expireDateStr =
          localStorageService.get(AUTHORIZATION_INFO)?.accessTokenExpiration;

        if (expireDateStr) {
          lsTokenReferesh();
        } else {
          routerPrivate();
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  api.interceptors.response.use(
    (response) => {
      if (response.status === 401) {
        lsTokenReferesh();
      }
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        localStorageService.remove(AUTHORIZATION_INFO);
        lsTokenReferesh();
      }

      !axios.isCancel(error) &&
        console.log("🚀 ~ file: axios_instance.ts ~ error:", error);
      const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;
      if (expectedError || axios.isCancel(error)) {
        return Promise.reject(error);
      }
      if (error.response && error.response.status === 500) {
        sAlert.fire({
          title:
            "درخواست شما با خطا مواجه شد. لطفا بعدا تلاش نمایید. درصورت مشاهده مجدد این خطا، با پشتیبان تماس بگیرید.",
          confirmButtonText: "تایید",
          position: "top",
        });
        return Promise.reject(error);
      }
      if (
        error.response &&
        error.response.status > 500 &&
        error.response.status < 600
      ) {
        sAlert.fire({
          title: "خطا در برقراری ارتباط! لطفا مجددا تلاش فرمایید. .",
          confirmButtonText: "تایید",
          position: "top",
        });
        return Promise.reject(error);
      }
      // در صورتیکه فراخوانی چک کردن برقراری سرور انجام شود نیازی به نمایش این پیغام نمی باشد
      // در صفحه اولیه در صورتی که سرور برقرار نباشد امکان تلاش مجدد قرار داده شده است
      if (error.config.url !== CheckHealthUrl) {
        sAlert.fire({
          title: "خطا در برقراری ارتباط! لطفا اینترنت خود را بررسی نمایید.",
          confirmButtonText: "تایید",
          position: "top",
        });
      }
    }
  );
  return api;
};

export default Api;
